const BELT_TEST_STATE = {
    INITIAL: 'initial',
    RUNNING: 'running',
    CLOSED: 'closed',
}

export default BELT_TEST_STATE
